/* globals */

const NewFilters = (() => {
  // DOM Elements
  const filter = document.getElementById("filter"),
    scrollTarget = document.getElementById("filter-scroll-target"),
    showFiltersModalButton = document.getElementById("show-filters-modal-btn"),
    filtersLength = document.querySelectorAll(".filters-apply-length"),
    onlineTherapySlider = document.getElementById("ot-slider"),
    onsiteTherapySlider = document.getElementById("os-slider"),
    closeFiltersModalButton = document.getElementById(
      "close-filters-modal-btn"
    ),
    clearFiltersBtn = document.getElementById("clear-filters-btn"),
    filtersModal = document.getElementById("filters-modal"),
    displayCheckboxesBtn = document.getElementById("more-filters"),
    servicesList = document.getElementById("services-list"),
    serviceAutocompleteInput = document.getElementById("sev_nav"),
    clearServiceBtn = document.getElementById("clear-sev-input"),
    locationElement = document.querySelector(
      '[data-component="geo_nav_input"]'
    ),
    locationList = document.getElementById("location-list"),
    locationAutocompleteInput = document.getElementById("geo_nav"),
    clearLocationBtn = document.getElementById("clear-geo-input"),
    checkboxesBox = document.getElementById("filter-checkboxes"),
    checks = document.getElementsByClassName("filter_checks"),
    priceCheckbox = document.getElementById("filter_price_order"),
    reviewsCheckbox = document.getElementById("filter_by_reviews"),
    navigateCta = document.querySelectorAll(".cta-navigate"),
    filtersCta = document.querySelectorAll(".filter-apply"),
    therapyTypeInput = document.getElementById("searchBoxTherapyTypeInput"),
    baseUrl = "/search?",
    MOBILE_WIDTH = 768,
    isMobile = document.documentElement.clientWidth < MOBILE_WIDTH;

  let therapyType,
    serviceValue,
    locationValue,
    locationType,
    neighborValue,
    priceValue,
    reviewsValue;

  /**
   * Initialize listings
   */
  const initFilters = () => {
    handleModalButton();
    handleFilterFixedOnScroll();
    handleTherapyTypeSwitcher();
    handleTotalFiltersNumber();
    handleClearInputButtons();

    clearServiceBtn.classList.remove("hide");
    clearLocationBtn.classList.remove("hide");

    addEventListeners();
  };

  /**
   * Add event listeners
   */
  const addEventListeners = () => {
    navigateCta.forEach((cta) =>
      cta.addEventListener("click", (event) =>
        handleApplyFiltersAndNavigate(event)
      )
    );

    servicesList.addEventListener("click", handleServiceListClick);
    locationList.addEventListener("click", handleLocationListClick);

    Array.from(checks).forEach((check) => {
      check.addEventListener("click", handleCheckboxClick);
    });

    if (isMobile) {
      handleClearFilters();
      Array.from(checks).forEach((check) => {
        check.addEventListener("click", handleEnableClearFilters);
      });
    } else {
      handleDisplayCheckboxes();
      locationAutocompleteInput.addEventListener("click", hideCheckboxesModal);
      serviceAutocompleteInput.addEventListener("click", hideCheckboxesModal);

      if (serviceAutocompleteInput.getAttribute("data-id") !== "0") {
        serviceAutocompleteInput.classList.add("autocomplete-with-result");
      }

      if (locationAutocompleteInput.getAttribute("data-id") !== "0") {
        locationAutocompleteInput.classList.add("autocomplete-with-result");
      }
    }
  };

  /**
   * Handle service list click
   */
  const handleServiceListClick = (e) => {
    handleEnableClearFilters();
    if (!e.target.classList.contains("js_no-results")) {
      handleTotalFiltersNumber();
    }
  };

  /**
   * Handle location list click
   */
  const handleLocationListClick = (e) => {
    handleEnableClearFilters();
    if (!e.target.classList.contains("js_no-results")) {
      handleTotalFiltersNumber();
    }
  };

  /**
   * Handle checkbox click
   */
  const handleCheckboxClick = () => {
    handleTotalFiltersNumber();
    handleEnableClearFilters();
  };

  /**
   * Handling Clear Input on click events
   */
  const handleClearInputButtons = () => {
    clearServiceBtn.addEventListener("click", () => {
      window.inputSevNav.clearQuery();
      handleEnableClearFilters();
      setTimeout(handleTotalFiltersNumber, 1);
    });

    clearLocationBtn.addEventListener("click", () => {
      window.inputGeoNav.clearQuery();
      setTimeout(handleEnableClearFilters, 1);
      setTimeout(handleTotalFiltersNumber, 10);
    });
  };

  /**
   * Handling Navigation Event
   * when user clicks on therapy online / onsite type switcher
   */
  const handleTherapyTypeSwitcher = (event) => {
    if (onlineTherapySlider) {
      onlineTherapySlider.addEventListener("click", () => {
        if (!onlineTherapySlider.classList.contains("js_disabled-slider")) {
          therapyTypeInput.checked = false;
          handleApplyFiltersAndNavigate(event);
        }
        onlineTherapySlider.classList.add("js_disabled-slider");
        onsiteTherapySlider.classList.remove("js_disabled-slider");
      });
    }

    if (onsiteTherapySlider) {
      onsiteTherapySlider.addEventListener("click", () => {
        if (!onsiteTherapySlider.classList.contains("js_disabled-slider")) {
          therapyTypeInput.checked = true;
          handleApplyFiltersAndNavigate(event);
        }
        onsiteTherapySlider.classList.add("js_disabled-slider");
        onlineTherapySlider.classList.remove("js_disabled-slider");
      });
    }
  };

  /**
   * Set position fixed on filters
   * when scrolling down
   */
  const handleFilterFixedOnScroll = () => {
    window.addEventListener("scroll", () => {
      if (!scrollTarget) return;
      const scrollTargetTop = scrollTarget.getBoundingClientRect().top;
      filter.classList.toggle("isFixed", scrollTargetTop <= 0);
    });
  };

  /**
   * DESKTOP
   * Display checkboxes options
   */
  const handleDisplayCheckboxes = () => {
    checkboxesBox.classList.add("hide");
    displayCheckboxesBtn.addEventListener("click", () => {
      checkboxesBox.classList.toggle("hide");
    });
  };

  /**
   * MOBILE
   * Open modal listener
   */
  const handleModalButton = () => {
    showFiltersModalButton.addEventListener("click", () => {
      filtersModal.classList.remove("hide-mobile");
      filter.style.zIndex = "5";
      document.body.classList.add("locked");
      handleCloseModalButton();
    });
  };

  /**
   * MOBILE
   * Enable Apply CTA and Clear filters button
   * only when at least one filter has been selected
   */
  const handleEnableClearFilters = () => {
    const serviceId = serviceAutocompleteInput.getAttribute("data-id");
    const locationId = locationAutocompleteInput.getAttribute("data-id");
    const serviceHasChanged = serviceId !== "0";
    const locationHasChanged = locationId !== "0";

    if (
      serviceHasChanged ||
      locationHasChanged ||
      priceCheckbox.checked ||
      reviewsCheckbox.checked
    ) {
      clearFiltersBtn.classList.remove("disabled");
      handleClearFilters();
    } else {
      clearFiltersBtn.classList.add("disabled");
      handleClearFilters();
    }
  };

  /**
   * MOBILE
   * Close modal listener
   */
  const handleCloseModalButton = () => {
    closeFiltersModalButton.addEventListener("click", () => {
      filtersModal.classList.add("hide-mobile");
      filter.style.zIndex = "4";
      document.body.classList.remove("locked");
    });
  };

  /**
   * DESKTOP
   * Hide checkbox modal
   */
  const hideCheckboxesModal = () => {
    if (!checkboxesBox.classList.contains("hide")) {
      checkboxesBox.classList.add("hide");
    }
  };

  /**
   * Checking how many filters have been selected
   * and displaying the total number in apply cta button
   */
  const handleTotalFiltersNumber = () => {
    let num = 0;

    if (serviceAutocompleteInput.getAttribute("data-id") !== "0") num++;
    if (locationAutocompleteInput.getAttribute("data-id") !== "0") num++;
    if (priceCheckbox.checked) num++;
    if (reviewsCheckbox.checked) num++;

    handleDisplayNumber(num);
  };

  /**
   * Displaying number
   */
  const handleDisplayNumber = (num) => {
    filtersLength.forEach((item) => {
      item.innerHTML = num > 0 ? num.toString() : "";
    });

    filtersCta.forEach((cta) => {
      cta.classList.toggle("withNumber", num > 0);
    });
  };

  /**
   * Reset Service Select
   */
  const resetServiceSelect = () => {
    window.inputSevNav.clearQuery();
    handleTotalFiltersNumber();
  };

  /**
   * Reset Location Select
   */
  const resetLocationSelect = () => {
    window.inputGeoNav.clearQuery();
    handleTotalFiltersNumber();
  };

  /**
   * Reset Checkboxes options
   */
  const resetCheckboxes = () => {
    Array.from(checks).forEach((check) => {
      check.checked = false;
    });
  };

  /**
   * MOBILE
   * Clear all selected filters
   */
  const handleClearFilters = () => {
    clearFiltersBtn.addEventListener("click", () => {
      resetServiceSelect();
      resetLocationSelect();
      resetCheckboxes();
      clearFiltersBtn.classList.add("disabled");
    });
  };

  /**
   * Get therapy type from switcher
   * onsite therapy = 0
   * online therapy = 1
   */
  const getTherapyType = () => {
    if (!therapyTypeInput) {
      therapyType = 0;
      return;
    }
    therapyType = therapyTypeInput.checked ? 0 : 1;
  };

  /**
   * Apply Filters and navigate to URL with parameters
   */
  const handleApplyFiltersAndNavigate = (event) => {
    event.preventDefault();
    getTherapyType();

    priceValue = priceCheckbox.checked ? 1 : 0;
    reviewsValue = reviewsCheckbox.checked ? 1 : 0;
    serviceValue = serviceAutocompleteInput.getAttribute("data-id");
    locationValue = locationAutocompleteInput.getAttribute("data-id");
    locationType = locationAutocompleteInput.getAttribute("data-type")
      ? `[${locationAutocompleteInput.getAttribute("data-type")}]`
      : `[${locationElement.getAttribute("data-selected-type")}]`;
    neighborValue = locationAutocompleteInput.getAttribute(
      "data-neighborhoodid"
    );

    const queryParams = [
      `therapytype=${therapyType}`,
      `service=${serviceValue}`,
      `location${locationType}=${locationValue}`,
      `neighborhood=${neighborValue}`,
      `pricefilter=${priceValue}`,
      `reviewfilter=${reviewsValue}`,
    ].join("&");

    location.href = `${baseUrl}${queryParams}`;
  };

  if (document.body.id === "ie_listing" && filter) {
    initFilters();
  }
})();

export default NewFilters;
